import script from "./SharedBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./SharedBanner.vue?vue&type=script&setup=true&lang=ts"

import "./SharedBanner.vue?vue&type=style&index=0&id=9e2d87dc&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.13_typescript@4.5.5__webpack@5.106.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e2d87dc"]])

export default __exports__